var _g, _g2, _ellipse, _ellipse2, _ellipse3, _g3, _path, _g4, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSection31(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 60,
    viewBox: "0 0 79 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1993_9018)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0611 56.9633C68.5446 56.9633 77.0432 48.4649 77.0432 37.9817C77.0432 27.4984 68.5446 19 58.0611 19C47.5776 19 39.079 27.4984 39.079 37.9817C39.079 41.512 40.0428 44.8172 41.7217 47.6486C42.3037 48.6302 42.5947 49.121 42.608 49.5486C42.6109 49.6423 42.6078 49.7094 42.5964 49.8024C42.5443 50.227 42.2508 50.6328 41.6638 51.4442C39.6693 54.2012 38.6721 55.5797 39.0965 56.4695C39.1742 56.6324 39.278 56.7816 39.4037 56.9112C40.0903 57.6186 41.7296 57.1633 45.0082 56.2526L48.3691 55.319C48.9544 55.1564 49.247 55.0751 49.5256 55.0925C49.8043 55.1098 50.1226 55.2426 50.7593 55.5081C53.0071 56.4456 55.4736 56.9633 58.0611 56.9633Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_1993_9018)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.1204 53.5198C66.6887 53.5198 73.6346 46.574 73.6346 38.006C73.6346 29.438 66.6887 22.4922 58.1204 22.4922C49.5522 22.4922 42.6062 29.438 42.6062 38.006C42.6062 40.8917 43.3941 43.5933 44.7665 45.9076C45.2425 46.7102 45.4804 47.1115 45.4912 47.4612C45.4936 47.5375 45.4911 47.5922 45.4818 47.6681C45.4393 48.0153 45.1993 48.347 44.7193 49.0105C43.0886 51.2648 42.2732 52.3919 42.6205 53.1193C42.6839 53.2521 42.7685 53.3737 42.871 53.4794C43.4321 54.0581 44.7725 53.6858 47.4532 52.9411L50.2027 52.1774C50.6808 52.0446 50.9199 51.9782 51.1476 51.9923C51.3752 52.0065 51.6354 52.1149 52.1556 52.3318C53.9919 53.0972 56.0068 53.5198 58.1204 53.5198Z",
    fill: "#FAC900"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.4306,
    cy: 38.2035,
    rx: 2.13319,
    ry: 2.13319,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.2484,
    cy: 38.2035,
    rx: 2.13319,
    ry: 2.13319,
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.0661,
    cy: 38.2035,
    rx: 2.13319,
    ry: 2.13319,
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_1993_9018)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.84 1H32.9425H21.045C19.9722 1 18.9433 1.42617 18.1848 2.18475C17.4262 2.94334 17 3.97221 17 5.04501V15.16C17 17.395 18.81 19.21 20.79 19.21H27.115C29.655 19.21 31.335 23.21 32.815 23.21C34.295 23.21 36.25 19.21 38.53 19.21H44.84C45.9133 19.2087 46.9421 18.7814 47.7006 18.022C48.459 17.2626 48.885 16.2333 48.885 15.16V5.04501C48.8837 3.97262 48.4571 2.94452 47.6988 2.18622C46.9405 1.42792 45.9124 1.00132 44.84 1Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5608 5.51661C36.092 5.51558 36.6125 5.66651 37.0608 5.95161C37.7752 6.4473 38.2826 7.18832 38.4864 8.0337C38.6901 8.87909 38.576 9.76987 38.1658 10.5366C37.5608 11.6866 35.0458 13.8366 32.8908 15.4616C32.8628 15.4851 32.8273 15.4975 32.7908 15.4966C32.7544 15.4966 32.7192 15.4843 32.6908 15.4616C30.5408 13.8366 28.0208 11.6866 27.4208 10.5366C27.0094 9.77011 26.8947 8.87899 27.0985 8.0333C27.3024 7.18762 27.8104 6.44657 28.5258 5.95161C28.9733 5.66495 29.4943 5.51388 30.0258 5.51661C30.4508 5.47706 30.8793 5.53135 31.2811 5.67564C31.6829 5.81992 32.048 6.05069 32.3508 6.35162L32.8158 6.98661L33.2808 6.35162C33.5795 6.04512 33.9441 5.81065 34.347 5.66598C34.7498 5.52131 35.1803 5.47022 35.6058 5.51661",
    fill: "#FAC900"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_dd_1993_9018)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.84 32H5.04501C3.97221 32 2.94334 32.4262 2.18475 33.1848C1.42617 33.9433 1 34.9722 1 36.045V46.16C1 48.395 2.81 50.21 4.79 50.21H11.115C13.655 50.21 15.335 54.21 16.815 54.21C18.295 54.21 20.25 50.21 22.53 50.21H28.84C29.9133 50.2087 30.9421 49.7814 31.7005 49.022C32.459 48.2626 32.885 47.2333 32.885 46.16V36.045C32.885 35.5138 32.7804 34.9878 32.5771 34.4971C32.3738 34.0063 32.0759 33.5604 31.7003 33.1848C31.3246 32.8091 30.8787 32.5112 30.388 32.3079C29.8972 32.1046 29.3712 32 28.84 32Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2648 43.4143C21.8712 42.3621 22.0738 41.1251 21.8349 39.9343C21.596 38.7436 20.9319 37.6805 19.9665 36.9436C19.0012 36.2067 17.8006 35.8463 16.589 35.9298C15.3774 36.0133 14.2376 36.5348 13.3824 37.3971C12.5273 38.2595 12.0152 39.4036 11.9418 40.6158C11.8684 41.828 12.2387 43.0256 12.9836 43.9848C13.7285 44.944 14.797 45.5992 15.9897 45.8283C17.1824 46.0573 18.4176 45.8444 19.4648 45.2293L21.6499 45.7293L21.2648 43.4143Z",
    fill: "#FAC900"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1993_9018",
    x: 37.9323,
    y: 17.9323,
    width: 40.1787,
    height: 41.1051,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.71182
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.533865
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.168 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1993_9018"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.533865
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.084 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1993_9018",
    result: "effect2_dropShadow_1993_9018"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1993_9018",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_1993_9018",
    x: 41.6688,
    y: 21.6195,
    width: 32.8383,
    height: 33.5966,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.581775
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.436331
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.168 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1993_9018"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.436331
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.084 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1993_9018",
    result: "effect2_dropShadow_1993_9018"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1993_9018",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_1993_9018",
    x: 16.2877,
    y: 0.287677,
    width: 33.3097,
    height: 24.1105,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.474882
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.356161
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.168 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1993_9018"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.356161
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.084 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1993_9018",
    result: "effect2_dropShadow_1993_9018"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1993_9018",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_dd_1993_9018",
    x: 0.287677,
    y: 31.2877,
    width: 33.3097,
    height: 24.1105,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.474882
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.356161
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.168 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1993_9018"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.356161
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.084 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1993_9018",
    result: "effect2_dropShadow_1993_9018"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1993_9018",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection31);
export default __webpack_public_path__ + "static/media/section31.e4816e6328a36462ad44140f9ff7c4da.svg";
export { ForwardRef as ReactComponent };